<div class="app-card-box p-none h-100"
     [routerLink]="['/experiences', 1]"
     style="max-width: 90vw;">

    <div class="img-bg w-100 h-10 app-border-radius"
         [appBackgroundImage]="experience.imageUrl"
         style="height: 220px;position: relative;">
    </div>

    <div class="content-padding pb-sm">
        <h5 style="text-wrap:auto;">{{experience.name}}</h5>
        <div class="d-flex ion-align-items-center ion-justify-content-between pt-sm">
            <div class="d-flex ion-align-items-center gap-2">
                <div>
                    <span class="material-symbols-outlined">timer</span>
                </div>
                <div>
                    <div class="m-none ">{{experience.durationLabel}}</div>
                </div>
            </div>
            <div *ngIf="experience.price">
                <h3>€ {{experience.price.toFixed(2)}}</h3>
            </div>
            <div *ngIf="!experience.price">
                <h3>Gratuito</h3>
            </div>
        </div>

    </div>
</div>
